import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  padding: '8px',
  gap: 8,
  '& > .MuiTypography-subtitle1': {
    color: spaceCadet[400],
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '24px',
    fontSize: 14,
  },
  '& > .MuiBox-root.header': {
    display: 'flex',
    flexDirection: 'row',
    gap: 25,
    '& > .MuiTypography-subtitle2': {
      color: spaceCadet[400],
      fontWeight: 600,
      lineHeight: '24px',
      fontSize: 14,
      width: 150,
    },
  },
  '& > .MuiBox-root.content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& > .MuiBox-root.cards': {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      '& > .MuiBox-root': {
        display: 'flex',
        flexDirection: 'row',
        gap: 25,
        '& > .MuiTypography-root': {
          color: spaceCadet[500],
          fontSize: 14,
          lineHeight: '16px',
          width: 150,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
      },
    },
    '& > .MuiButtonBase-root.seeMore': {
      color: ultraMarine[500],
      fontSize: 14,
      lineHeight: '16px',
      alignSelf: 'flex-start',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

});

export default StyledBox;
